export default {"src":"/_next/static/media/VTRS.f8b78931.svg","height":18,"width":18};